import { render, staticRenderFns } from "./BaseWelcomeStepPage.vue?vue&type=template&id=70e0ab82&scoped=true"
import script from "./BaseWelcomeStepPage.vue?vue&type=script&lang=ts"
export * from "./BaseWelcomeStepPage.vue?vue&type=script&lang=ts"
import style0 from "./BaseWelcomeStepPage.vue?vue&type=style&index=0&id=70e0ab82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0ab82",
  null
  
)

export default component.exports